var React = require('react');

function PlusSign (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"currentColor","d":"M11 0v20H9V0z","key":0}),React.createElement("path",{"fill":"currentColor","d":"M20 11H0V9h20z","key":1})]);
}

PlusSign.defaultProps = {"width":"20","height":"20","fill":"none","viewBox":"0 0 20 20"};

module.exports = PlusSign;

PlusSign.default = PlusSign;
